import React, { useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, CheckCircle2, XCircle, Clock, Activity, Percent, Truck, ThumbsDown, Ban, Building2, Users, Boxes, AlertTriangle, PackageMinus, PackageCheck, PackageX, AlertCircle, MapPin, Package } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Select } from '../components/ui/Select';
import { StatCard } from '../components/dashboard/StatCard';
import { StatusBreakdown } from '../components/dashboard/StatusBreakdown';
import { OrderFunnelChart } from '../components/dashboard/OrderFunnelChart';
import { DeliveryPickupChart } from '../components/dashboard/DeliveryPickupChart';
import { TopList } from '../components/dashboard/TopList';
const TOP_PRODUCTS = [{
  id: 'p1',
  label: 'Glucare 500 Mg 50 Tab',
  value: 549,
  sku: '1013037'
}, {
  id: 'p2',
  label: 'Jp Triplex Vitamins B 30 Tab',
  value: 546,
  sku: '1017548'
}, {
  id: 'p3',
  label: 'Aciloc 20 MG 14 Cap',
  value: 532,
  sku: '1011901'
}, {
  id: 'p4',
  label: 'OMERAL 20 mg capsule20...',
  value: 532,
  sku: '1042556'
}, {
  id: 'p5',
  label: 'Tabuvan 80 Mg 30 Tab',
  value: 365,
  sku: '1014249'
}, {
  id: 'p6',
  label: 'Atorva 20 Mg 30 Tab',
  value: 328,
  sku: '1012088'
}, {
  id: 'p7',
  label: 'Topferol 50000 IU 8 Tab',
  value: 314,
  sku: '1018641'
}, {
  id: 'p8',
  label: 'Lodipam 5 Mg 30 Tab',
  value: 306,
  sku: '1013352'
}, {
  id: 'p9',
  label: 'AVALON AMODIP 5 MG 3...',
  value: 306,
  sku: '1020858'
}, {
  id: 'p10',
  label: 'Amlocard 5 Mg 30 Tab#',
  value: 306,
  sku: '1011968'
}];
const TOP_UNAVAILABLE = [{
  id: 'u1',
  label: 'Glucare XR 750 Mg 60 Tab',
  value: 16098,
  sku: '1013036'
}, {
  id: 'u2',
  label: 'White Soft Paraffin SPI 30 ...',
  value: 12554,
  sku: '1036300'
}, {
  id: 'u3',
  label: 'SACO WHITE SOFT PARAF...',
  value: 12368,
  sku: '1042626'
}, {
  id: 'u4',
  label: 'Optive UD Solution 30 Pcs...',
  value: 9694,
  sku: '1013720'
}, {
  id: 'u5',
  label: 'Eltroxin 100 Mcg 100 Tab',
  value: 9048,
  sku: '1012743'
}, {
  id: 'u6',
  label: 'Januvia 100 Mg 28 Tab',
  value: 7777,
  sku: '1013199'
}, {
  id: 'u7',
  label: 'Unifresh 0.5% Eye Drop 0....',
  value: 7120,
  sku: '1022419'
}, {
  id: 'u8',
  label: 'Tacroz 0.1% Forte Oint 10 ...',
  value: 5969,
  sku: '1014251'
}, {
  id: 'u9',
  label: "Maxical plain600 MG30'S",
  value: 5927,
  sku: '1042628'
}, {
  id: 'u10',
  label: 'Empagliflozin SPC 25mg 3...',
  value: 5404,
  sku: '1034830'
}];
const TOP_BRANCHES = [{
  id: 'b1',
  label: 'HHP304',
  value: 191,
  subLabel: 'Jeddah'
}, {
  id: 'b2',
  label: 'HHP114',
  value: 186,
  subLabel: 'Buraydah'
}, {
  id: 'b3',
  label: 'HHP001',
  value: 181,
  subLabel: 'Riyadh'
}, {
  id: 'b4',
  label: 'HHP593',
  value: 164,
  subLabel: 'Riyadh'
}, {
  id: 'b5',
  label: 'HHP142',
  value: 156,
  subLabel: 'Riyadh'
}, {
  id: 'b6',
  label: 'HHP003',
  value: 153,
  subLabel: 'Riyadh'
}, {
  id: 'b7',
  label: 'HHP425',
  value: 146,
  subLabel: 'Riyadh'
}, {
  id: 'b8',
  label: 'HHP072',
  value: 145,
  subLabel: 'Riyadh'
}, {
  id: 'b9',
  label: 'HHP350',
  value: 137,
  subLabel: 'Jeddah'
}, {
  id: 'b10',
  label: 'HHP024',
  value: 129,
  subLabel: 'Riyadh'
}];
const TOP_CITIES = [{
  id: 'c1',
  label: 'Riyadh',
  value: 1839,
  subLabel: 'Tuwaiq'
}, {
  id: 'c2',
  label: 'Riyadh',
  value: 865,
  subLabel: 'Al Qadisiyah'
}, {
  id: 'c3',
  label: 'Riyadh',
  value: 756,
  subLabel: 'Middle Oraija'
}, {
  id: 'c4',
  label: 'Jeddah',
  value: 736,
  subLabel: 'As Sanabel'
}, {
  id: 'c5',
  label: 'Riyadh',
  value: 724,
  subLabel: 'Al Awaly'
}, {
  id: 'c6',
  label: 'Makkah',
  value: 673,
  subLabel: 'Al Umrah'
}, {
  id: 'c7',
  label: 'Riyadh',
  value: 600,
  subLabel: 'Al Fayha'
}, {
  id: 'c8',
  label: 'Riyadh',
  value: 580,
  subLabel: 'Al Aziziyah'
}, {
  id: 'c9',
  label: 'Riyadh',
  value: 554,
  subLabel: 'Al Dar Al Baida'
}, {
  id: 'c10',
  label: 'Jeddah',
  value: 501,
  subLabel: 'Ar Rughamah'
}];
export function Dashboard() {
  const [timeRange, setTimeRange] = useState('last_7_days');
  const [customRange, setCustomRange] = useState({
    from: '',
    to: ''
  });
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 10
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <motion.div initial="hidden" animate="visible" variants={containerVariants} className="space-y-8 pb-12" data-id="element-551">
      <motion.div variants={itemVariants} className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-552">
        <div data-id="element-553">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-554">
            Dashboard Overview
          </h1>
          <p className="text-slate-500" data-id="element-555">
            Welcome back to Waseel Jisr Middleware Admin.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3" data-id="element-556">
          <AnimatePresence data-id="element-557">
            {timeRange === 'custom' && <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: 20
          }} className="flex items-center gap-2 bg-white border border-slate-200 rounded-lg px-3 py-1.5 shadow-sm" data-id="element-558">
                <div className="flex items-center gap-2" data-id="element-559">
                  <span className="text-xs font-medium text-slate-500" data-id="element-560">
                    From:
                  </span>
                  <input type="date" className="text-xs border-none p-0 focus:ring-0 w-28" value={customRange.from} onChange={e => setCustomRange(prev => ({
                ...prev,
                from: e.target.value
              }))} data-id="element-561" />
                </div>
                <div className="w-px h-4 bg-slate-200 mx-1" data-id="element-562" />
                <div className="flex items-center gap-2" data-id="element-563">
                  <span className="text-xs font-medium text-slate-500" data-id="element-564">
                    To:
                  </span>
                  <input type="date" className="text-xs border-none p-0 focus:ring-0 w-28" value={customRange.to} onChange={e => setCustomRange(prev => ({
                ...prev,
                to: e.target.value
              }))} data-id="element-565" />
                </div>
              </motion.div>}
          </AnimatePresence>

          <div className="relative min-w-[160px]" data-id="element-566">
            <Select value={timeRange} onChange={e => setTimeRange(e.target.value)} options={[{
            value: 'last_hour',
            label: 'Last Hour'
          }, {
            value: 'last_24_hours',
            label: 'Last 24 Hours'
          }, {
            value: 'last_7_days',
            label: 'Last 7 Days'
          }, {
            value: 'last_30_days',
            label: 'Last 30 Days'
          }, {
            value: 'custom',
            label: 'Custom Range'
          }]} className="border-primary-500 focus:ring-primary-500 text-sm" data-id="element-567" />
          </div>
        </div>
      </motion.div>

      {/* Top KPIs - 3 per row */}
      <motion.div variants={itemVariants} className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4" data-id="element-568">
        <StatCard title="Total Orders" value="27,396" icon={ShoppingCart} iconColor="text-blue-600" trend={{
        value: '12%',
        isPositive: true,
        label: 'vs last period'
      }} description="The total number of prescription orders received across all branches during the selected time period." data-id="element-569" />
        <StatCard title="Successful Orders" value="3,768" icon={CheckCircle2} iconColor="text-emerald-600" percentOfTotal="13.8%" trend={{
        value: '8%',
        isPositive: true,
        label: 'vs last period'
      }} description="Orders that have been successfully completed — includes both Delivered (shipped to patient) and Picked (collected by patient at branch)." data-id="element-570" />
        <StatCard title="Pending Orders" value="68" icon={Clock} iconColor="text-amber-600" percentOfTotal="2.7%" trend={{
        value: '5%',
        isPositive: false,
        label: 'vs last period'
      }} description="Orders currently waiting for action — either awaiting insurance authorization (ERX Hub approval) or waiting for patient confirmation." data-id="element-571" />
        <StatCard title="Delivery Success Rate" value="95.2%" icon={Truck} iconColor="text-emerald-600" trend={{
        value: '1%',
        isPositive: true,
        label: 'vs last period'
      }} description="Percentage of dispatched orders that were successfully delivered or picked up. Excludes orders lost, damaged, or not picked up." data-id="element-572" />
        <StatCard title="Cancellation Rate" value="0%" icon={Ban} iconColor="text-orange-600" trend={{
        value: '0.5%',
        isPositive: true,
        label: 'vs last period'
      }} description="Percentage of received orders that were cancelled. Calculated as (Cancelled Orders / Total Orders) × 100. Includes cancellations by patient, pharmacy, or system timeout." data-id="element-573" />
        <StatCard title="Total Branches" value="256" icon={Building2} iconColor="text-slate-600" trend={{
        value: '2',
        isPositive: true,
        label: 'vs last period'
      }} description="The total number of active pharmacy branches connected to the Yusur platform." data-id="element-574" />
        <StatCard title="Total Pharmacists" value="45" icon={Users} iconColor="text-slate-600" trend={{
        value: '5',
        isPositive: true,
        label: 'vs last period'
      }} description="The total number of registered pharmacists across all branches who can process and dispense orders." data-id="element-575" />
      </motion.div>

      {/* Stock Overview KPIs */}
      <motion.div variants={itemVariants} className="space-y-4" data-id="element-576">
        <h3 className="text-lg font-semibold text-slate-900" data-id="element-577">Stock Overview</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-578">
          <StatCard title="Total Items" value="465,089" icon={Boxes} iconColor="text-teal-600" description="Total number of item-branch combinations tracked across all branches in the stock inventory." data-id="element-579" />
          <StatCard title="Items 1–2 pcs" value="104,404" icon={AlertTriangle} iconColor="text-red-600" description="Items with critically low stock levels (1 to 2 pieces). Immediate restocking recommended." data-id="element-580" />
          <StatCard title="Items 2–3 pcs" value="30,303" icon={PackageMinus} iconColor="text-amber-600" description="Items with low stock levels (more than 2 up to 3 pieces). Monitor closely for restocking." data-id="element-581" />
          <StatCard title="Above 3 pcs" value="81,579" icon={PackageCheck} iconColor="text-emerald-600" description="Items with healthy stock levels (more than 3 pieces). No immediate action needed." data-id="element-582" />
          <StatCard title="Out of Stock" value="248,803" icon={PackageX} iconColor="text-red-600" description="Items with zero stock. Cannot be dispensed until restocked." data-id="element-583" />
        </div>
      </motion.div>

      {/* Order Status Breakdown Section - Full Width */}
      <motion.div variants={itemVariants} className="space-y-4" data-id="element-584">
        <div className="flex items-center gap-2" data-id="element-585">
          <h3 className="text-lg font-semibold text-slate-900" data-id="element-586">
            Order Status Breakdown
          </h3>
          <span className="text-sm text-slate-400" data-id="element-587">(27,396 total)</span>
        </div>
        <StatusBreakdown data-id="element-588" />
      </motion.div>

      {/* Order Funnel & Top Products */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-589">
        <motion.div variants={itemVariants} data-id="element-590">
          <OrderFunnelChart data-id="element-591" />
        </motion.div>
        <motion.div variants={itemVariants} data-id="element-592">
          <TopList title="Top 10 Products" items={TOP_PRODUCTS} icon={<Package className="w-5 h-5" data-id="element-594" />} barColor="bg-primary-600" data-id="element-593" />
        </motion.div>
      </div>

      {/* Top Lists Row 2: Unavailable, Branches, Cities */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-595">
        <motion.div variants={itemVariants} data-id="element-596">
          <TopList title="Top 10 Unavailable Items" items={TOP_UNAVAILABLE} icon={<AlertCircle className="w-5 h-5" data-id="element-598" />} barColor="bg-red-500" valueLabel="Requests" data-id="element-597" />
        </motion.div>
        <motion.div variants={itemVariants} data-id="element-599">
          <TopList title="Top 10 Branches" items={TOP_BRANCHES} icon={<Building2 className="w-5 h-5" data-id="element-601" />} barColor="bg-blue-600" data-id="element-600" />
        </motion.div>
        <motion.div variants={itemVariants} data-id="element-602">
          <TopList title="Top 10 Cities" items={TOP_CITIES} icon={<MapPin className="w-5 h-5" data-id="element-604" />} barColor="bg-purple-600" data-id="element-603" />
        </motion.div>
      </div>

      {/* Delivery vs Pickup Section */}
      <motion.div variants={itemVariants} data-id="element-605">
        <DeliveryPickupChart deliveryCount={9634} pickupCount={2219} prevDeliveryCount={9100} prevPickupCount={2100} data-id="element-606" />
      </motion.div>
    </motion.div>;
}